import {call, put, takeEvery, select} from 'redux-saga/effects';

import constants from '../constants';
import * as RequestTools from '../tools/request';
import * as reviewsActions from '../actions/reviewsActionCreators';
import * as applicationActions from '../actions/applicationActionCreators';
import {extractPaginationParams} from '../tools/request';
import {notification} from 'antd';

const {API, ACTIONS} = constants;

export const fetchReviewsRequest = (params) => RequestTools.ajax({url: API.REVIEWS_PATH, params});
export const fetchReviewsStatsRequest = () => RequestTools.ajax({url: API.REVIEWS_STATS_PATH});
export const fetchPartnersReviewsRequest = () => RequestTools.ajax({url: API.PARTNERS_REVIEWS_PATH});
export const createReviewRequest = (params) => RequestTools.ajaxPost({url: API.REVIEWS_PATH, method: 'POST', data: params});

export function * fetchReviews(action) {
  const
    {reviewsState: {paginator: {per_page}}} = yield select(),
    page = action.payload.options?.page || 1;
  try {
    const
      response = yield call(fetchReviewsRequest, {page, per_page}),
      paginator = {
        page,
        ...extractPaginationParams(response)
      };

    yield put(reviewsActions.fetchReviewsSuccess(response.data, paginator));
  } catch (e) {
    yield put(reviewsActions.fetchReviewsFailed());
  }
}

export function * fetchReviewsStats(action) {
  try {
    const
      response = yield call(fetchReviewsStatsRequest);

    yield put(reviewsActions.fetchReviewsStatsSuccess(response.data));
  } catch (e) {
    yield put(reviewsActions.fetchReviewsStatsFailed());
  }
}

export function * fetchPartnersReviews(action) {
  try {
    const
      response = yield call(fetchPartnersReviewsRequest);

    yield put(reviewsActions.fetchPartnersReviewsSuccess(response.data));
  } catch (e) {
    yield put(reviewsActions.fetchPartnersReviewsFailed());
  }
}
export function * createReview(action) {
  try {
    const
      response = yield call(createReviewRequest, action.payload.params);
    if (response.data.errors) {
      yield put(reviewsActions.createReviewFailed(response.data));
    } else {
      yield call(notification.success, {message: '', description: 'Ваш отзыв успешно отправлен.'});
      yield put(reviewsActions.createReviewSuccess(response.data));
      yield put(reviewsActions.resetNewReview());
      yield put(applicationActions.redirect(constants.ROUTES.REVIEWS_PATH));
    }

  } catch (e) {
    yield put(reviewsActions.createReviewFailed(e));
  }
}

function * articlesSaga() {
  yield takeEvery(ACTIONS.FETCH_REVIEWS, fetchReviews);
  yield takeEvery(ACTIONS.FETCH_REVIEWS_STATS, fetchReviewsStats);
  yield takeEvery(ACTIONS.FETCH_PARTNERS_REVIEWS, fetchPartnersReviews);
  yield takeEvery(ACTIONS.CREATE_REVIEW, createReview);
}

export default articlesSaga;
